var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaybackicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H26V17.25H1V1Z",
    stroke: "#2F2D30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 22.875H2.25M9.125 22.875H24.75M12.25 6.625L16 9.125L12.25 11.625V6.625ZM9.125 22.875C9.125 23.1212 9.0765 23.365 8.98227 23.5925C8.88805 23.82 8.74994 24.0267 8.57583 24.2008C8.40172 24.3749 8.19502 24.513 7.96753 24.6073C7.74005 24.7015 7.49623 24.75 7.25 24.75C7.00377 24.75 6.75995 24.7015 6.53247 24.6073C6.30498 24.513 6.09828 24.3749 5.92417 24.2008C5.75006 24.0267 5.61195 23.82 5.51773 23.5925C5.4235 23.365 5.375 23.1212 5.375 22.875C5.375 22.3777 5.57254 21.9008 5.92417 21.5492C6.27581 21.1975 6.75272 21 7.25 21C7.74728 21 8.22419 21.1975 8.57583 21.5492C8.92746 21.9008 9.125 22.3777 9.125 22.875V22.875Z",
    stroke: "#2F2D30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackicon);
export default __webpack_public_path__ + "static/media/playbackicon.1219f372af9cfb0cecfffc8a6567740a.svg";
export { ForwardRef as ReactComponent };